import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { AUTH_DETAILS, AUTH_TOKEN, MENU_ITEMS } from 'constants/AuthConstant';
import masterService from 'services/MasterService';
import { useDispatch } from 'react-redux';



export const initialState = {
	deploading: false,
	message: '',
	deplist:null,
	desglist:null,
	desgloading:false,
    freqlist:null,
	freqloading:false,
}



export const departmentListAll = createAsyncThunk('department/list',async (data, { rejectWithValue }) => {
	
	
    try {
		const response = await masterService.getTaskList(data)
		return response.data;
		
		
	} catch (err) {
		
		return rejectWithValue(err.response?.data?.message || 'Error')
	}
})



export const masterSlice = createSlice({
	name: 'master',
	initialState,
	reducers: {
			
		departmentList: (state, action) => {
			state.deploading = true
			state.deplist = action.payload
		},
		
	},
	extraReducers: (builder) => {
		builder
			.addCase(departmentListAll.pending, (state) => {
		
				state.deploading = false
			})
			.addCase(departmentListAll.fulfilled, (state, action) => {
				state.deploading = true
				state.deplist = action.payload
			})
			
			
	},
})

export const { 
	departmentList
    
    
} = masterSlice.actions

export default masterSlice.reducer